import type { Dayjs, ManipulateType } from 'dayjs';
import { presetMap } from './constants';
import type { TPresetKey } from './types';

export const disabledPickerDates =
  (value: number, unit: ManipulateType) => (current: Dayjs, info: { from?: Dayjs }) => {
    if (!info.from) return false;

    const oneMonthFromStart = info.from.add(value, unit);
    return current.isAfter(oneMonthFromStart);
  };

export const getPresets = (keys: TPresetKey[]) => keys.map((key) => presetMap[key]);
